import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    addressline1: {
      validations: []
    },
    city: {
      validations: []
    },
    state: {
      validations: []
    },
    postal: {
      validations: []
    },
    clientname: {
      validations: []
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    sitename: {
      validations: [
        { type: 'required', message: 'Please provide venue or location name' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please provide type of event' }
      ]
    },
    category: {
      validations: [
        { type: 'required', message: 'Please select type of service' }
      ]
    },
    eventextra3: {
      validations: [
        { type: 'required', message: 'Please select beverage service' }
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'EVENT INFORMATION',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Small',
            label: 'First Name:*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Small',
            label: 'Last Name:*',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Small',
            label: 'Address:',
            mapping: 'addressline1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Small',
            label: 'City:',
            mapping: 'city'
          },
          {
            type: 'text',
            size: 'Small',
            label: 'State:',
            mapping: 'state'
          },
          {
            type: 'text',
            size: 'Small',
            label: 'Zip:',
            mapping: 'postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company:',
            mapping: 'clientname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Small',
            label: 'Phone:*',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Small',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Small',
            label: 'Date of Event:*',
            mapping: 'eventDate'
          },
          {
            type: 'text',
            size: 'Small',
            label: 'Number of Guests:',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Small',
            label: 'Venue/Location Info:*',
            mapping: 'sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Small',
            label: 'Occasion:*',
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'FOOD',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Type of service desired (select all that apply):*',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Small',
            label: '',
            options: [
              { label: 'Sit-down', value: 'Sit-down'},
              { label: 'Buffet', value: 'Buffet' },
              { label: 'Family Style', value: 'Family Style' },
              { label: 'Stations', value: 'Stations' },
              { label: 'Passed Appetizers', value: 'Passed Appetizers' }
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'BEVERAGE',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: '(select all that apply):*',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Small',
            label: '',
            options: [
              { label: 'Full Bar', value: 'SFull Bar'},
              { label: 'Non-Alcoholic', value: 'Non-Alcoholic' },
              { label: 'Beer and Wine Only', value: 'Beer and Wine Only' }
            ],
            mapping: 'eventextra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Small',
            label: 'Is there anything else you would like to add?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'Send'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Melons Catering and Events Contact Form',
    formId: '261',
    clientKey: '2091E79C-99A2-43DA-B61C-6F3FB8FD5F31',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
